// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmail_root__2preE"};